import {BASE_TRACK_API_URL} from '@constants/config'
import {apiRequestWithAuth} from '@helpers/query/apiRequestWithAuth'
import {OnShowError} from '@baseTypes/base'
import {
	IAccountCameraSnapshot,
	ICameraPhotoStats,
	ICameraPreview
} from '@containers/monitoringPlatform/photoFixation/types'

const BASE_URL_ACCOUNTS = `${BASE_TRACK_API_URL}/v1/accounts`

export const getCameraSnapshotDevicesApi = async (
	accountId: number,
	onError?: OnShowError
): Promise<IAccountCameraSnapshot[]> => {
	const url = `${BASE_URL_ACCOUNTS}/${accountId}/cameras/snapshots/devices`
	return await apiRequestWithAuth<IAccountCameraSnapshot[]>({
		url,
		options: {
			method: 'GET',
		},
		onError
	})
}

export const getCameraPhotoStatsApi = async (
	accountId: number,
	onError?: OnShowError
): Promise<ICameraPhotoStats[]> => {
	const url = `${BASE_URL_ACCOUNTS}/${accountId}/cameras/snapshots/stats`
	return await apiRequestWithAuth<ICameraPhotoStats[]>({
		url,
		options: {
			method: 'GET',
		},
		onError
	})
}

export const getCameraPreviewsApi = async (
	accountId: number,
	onError?: OnShowError
): Promise<ICameraPreview[]> => {
	const url = `${BASE_URL_ACCOUNTS}/${accountId}/cameras/snapshots/previews`
	return await apiRequestWithAuth<ICameraPreview[]>({
		url,
		options: {
			method: 'GET',
		},
		onError
	})
}
